<script setup>
import { onBeforeUnmount, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import GuestHeader from "@components/layouts/headers/GuestHeader.vue";
import GuestFooter from "@components/layouts/footers/GuestFooter.vue";
import { useShoppingCartStore } from "@composables/use_shopping_cart_store";
import { useMicelaneasStore } from "@composables/use_micelaneas_store";
import { useBrandsStore } from "@composables/use_brands_store";
import { usePromotionsStore } from "@composables/use_promotions_store";
import { useInventoryStore } from "@composables/use_inventory_store";
import { useAuthStore } from "@composables/use_auth_store";

import { useMisComprasStore } from "@composables/use_mis_compras_store";
import { misComprasStore } from "@stores/mis_compras_store.js";
import {
  encriptar,
  desencriptar,
  encriptarCampo,
  siExistenDatosEncriptar,
} from "@composables/use_encript.js";

const { getTokenStatus, getCliente, getEmail, token } = useAuthStore();
const { getMicelaneas } = useMicelaneasStore();
const { getBrands } = useBrandsStore();
const { getPromotions } = usePromotionsStore();
const { getCategories, getPromos, getFeatured, getSubcategories } =
  useInventoryStore();
const { initShoppingCart, expiredCheck } = useShoppingCartStore();
const { initMisCompras } = useMisComprasStore();

const route = useRoute();
const router = useRouter();
const isShowsRoute = computed(() => {
  return route.name === 'Shows' || route.name === 'ShowGallery';
});

onMounted(async () => {
  console.log("guest layout mounted");
  siExistenDatosEncriptar();
  const estado = await getTokenStatus();
  if (estado === "expirada") {
    alert("La sesión expiró. Volvé a iniciar sesión.");
    if (route.name !== "Login" && route.name !== "LoginPirotecnia") {
      const pirotecnia =
        route.fullPath.includes("pirotecnia") ||
        window.location.href.includes("?pirotecnia");
      router.push(pirotecnia ? "/login/?pirotecnia" : "/login");
    }
  }
  getCliente();
  getEmail();
  expiredCheck();
  initShoppingCart();
  getMicelaneas();
  getBrands();
  getPromotions();
  getCategories();
  const dominioURL = window.location.href;
  var soloPirotecnia = dominioURL.includes("?pirotecnia");
  if (soloPirotecnia) {
    console.log("Es solo Pirotecnia");
    getSubcategories("65");
  }
  getPromos();
  getFeatured();
});

onBeforeUnmount(() => {});

function showLinkMenu() {
  console.log("ontap");
  let linksMenu = document.querySelectorAll(".footer-network-link");
  if (linksMenu) {
    linksMenu.forEach((item) => {
      item.classList.add("d-none");
    });
  }
}
</script>

<template>
  <!-- GuestLayout -->
  <div @click.stop="showLinkMenu" class="flex flex-col">
    <GuestHeader />
    <!-- Spacer to push content below fixed header (banner ~30px + logo row ~46px + red bar ~52px) -->
    <div 
      class="h-[162px] sm:h-[162px]"
      :class="isShowsRoute ? 'bg-[#08090d]' : 'bg-white'"
    ></div>
    <router-view class="flex-1" />
    <GuestFooter />
  </div>
</template>
